module.exports = __webpack_public_path__ + "img/modal-1on1.443126da.png";